module.exports = __webpack_public_path__ + "static/media/Github.e8a7643c.png";